export default __webpack_public_path__ + "static/image-43-a10047398b67aecea520bc44a3eeb878.jpg";